import typesActions from '../actions/typesActions';

const typesReducer = (state = [], action) => {
  switch (action.type) {
    case typesActions.constants.set:
      return action.payload;
    default:
      return state;
  }
};

export default typesReducer;
